"use strict";

import "../scss/style.scss";

import IntersectionObserverScroll from "./IntersectionObserver.js";
import VanillaAccordion from "./VanillaAccordion.js";
import VanillaPageReload from "./VanillaPageReload.js";
import VanillaVoiceMore from "./VanillaVoiceMore.js";
import VanillaTab from "./VanillaTab.js";
import VanillaInputFilled from "./VanillaInputFilled.js";
import VanillaScrollActive from "./VanillaScrollActive.js";
import VanillaSmoothScroll from "./VanillaSmoothScroll.js";
import VanillaUnwrapHeadingStrong from "./VanillaUnwrapHeadingStrong.js";

document.addEventListener(
  "DOMContentLoaded",
  () => {
    new IntersectionObserverScroll(".js-inview", "js-inview-acv");
    new VanillaAccordion(
      ".js-accordion-box",
      ".js-accordion-trigger",
      ".js-accordion-cnt",
      { closeOthers: false },
    );
    new VanillaPageReload();
    new VanillaVoiceMore();
    new VanillaTab("#js-page-tab", ".js-tab-trigger", ".js-tab-cnt");
    new VanillaInputFilled(
      "#last-name, #first-name, #last-name-kana, #first-name-kana, #tel-1, #tel-2, #tel-3,#email, #contact-message",
    );
    new VanillaScrollActive("#js-page", "js-header-active");
    new VanillaSmoothScroll();
    new VanillaUnwrapHeadingStrong();
  },
  false,
);
